import { fuelToolsApiAxios } from './interceptor';

const FuelAnalyticsService = {
  async post(route: string, data: any) {
    try {
      const fullRoute = `${route}`;
      const res = await fuelToolsApiAxios.post(fullRoute, data);
      return res.data;
    } catch (err) {
      console.error('err', err);
      throw err;
    }
  },

  async get(route: string, queryParams: any = null) {
    let fullRoute = `${route}`;
    if (queryParams != null) {
      const qs = Object.keys(queryParams)
        .map((key) => `${key}=${queryParams[key]}`)
        .join('&');
      fullRoute += `?${qs}`;
    }
    try {
      const res = await fuelToolsApiAxios.get(fullRoute);
      return res.data;
    } catch (err) {
      console.error('err', err);
      throw err;
    }
  },
};

export default FuelAnalyticsService;
